import { render } from "./beneficiary_map.vue?vue&type=template&id=2f8f26e7&scoped=true"
import script from "./beneficiary_map.vue?vue&type=script&lang=js"
export * from "./beneficiary_map.vue?vue&type=script&lang=js"

import "./beneficiary_map.vue?vue&type=style&index=0&id=2f8f26e7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8f26e7"]])

export default __exports__